import styled from "styled-components";

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #858586;
  opacity: 0.4;
`;

export default Divider;
